import React from 'react'
import { ChevronDown, Hourglass } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import store from '../../../state/store'

class DisableAutomaticTrackButton extends React.Component {

  onClick = () => {
    store.emit('enquiry:automatic_track:disable', this.props.enquiry_id)
  }

  render() {
    const title = 'Click to disable automatic follow up & deactivation'

    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" size="sm" title={title}>
            <Hourglass className="size-4 animate-spin"/> AUTO <ChevronDown className="size-3.5"/>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={this.onClick}>Disable Autotrack</DropdownMenuItem>
          <DropdownMenuItem>Cancel</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }
}

export default DisableAutomaticTrackButton
